import { useState } from 'react';
import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Select, ErrorMessage } from '@kiper/ui';
import {
  Title,
  Subtitle,
  ButtonSubmit,
  Col,
  ButtonLink,
  FormGroup,
} from './styles';

// Passo "Para qual contexto é esta máquina?": generaliza a escolha entre
// Parceiro e condomínio (porteiro com vínculo de condomínio — fase 2). Só
// existe quando o sign-in barrado devolve mais de uma opção elegível de um
// dos dois tipos — com uma só, o passo é invisível (routeWorkstationOutcome
// em hooks/useLoginActions.js já resolve o contexto sozinho e pula direto
// para o cadastro). O backend nunca preenche partners e condominiums ao
// mesmo tempo, então a lista de condomínios decide o "kind" deste passo: o
// porteiro com condomínio nunca vê a lista de parceiros.
const LoginWorkstationContextSelect = ({
  values,
  setFieldValue,
  setCurrentStep,
  steps,
}) => {
  const [t] = useTranslation('login');
  const [selected, setSelected] = useState(null);
  const [showRequiredError, setShowRequiredError] = useState(false);

  const kind =
    (values.condominiums || []).length > 0 ? 'condominium' : 'partner';
  const contextField =
    kind === 'condominium' ? 'condominiumContextId' : 'partnerContextId';
  const contextOptions =
    (kind === 'condominium' ? values.condominiums : values.partners) || [];

  const options = contextOptions.map(option => ({
    value: kind === 'condominium' ? option.id : option.partnerContextId,
    label: option.name,
  }));

  const handleChange = option => {
    setSelected(option);
    setShowRequiredError(false);
  };

  const handleContinue = () => {
    if (!selected) {
      setShowRequiredError(true);
      return;
    }
    setFieldValue(contextField, selected.value);
    setCurrentStep(steps.workstationRegister);
  };

  return (
    <Col>
      <Title>{t(`workstation.${kind}-select.title`)}</Title>
      <Subtitle>{t(`workstation.${kind}-select.subtitle`)}</Subtitle>
      <FormGroup>
        <Select
          options={options}
          value={selected}
          onChange={handleChange}
          placeholder={t(`workstation.${kind}-select.placeholder`)}
        />
        {showRequiredError && (
          <ErrorMessage>
            {t(`workstation.${kind}-select.required`)}
          </ErrorMessage>
        )}
      </FormGroup>
      <ButtonSubmit block color="primary" onClick={handleContinue}>
        {t(`workstation.${kind}-select.continue`)}
      </ButtonSubmit>
      <ButtonLink color="link" onClick={() => setCurrentStep(steps.email)}>
        {t(`workstation.${kind}-select.back`)}
      </ButtonLink>
    </Col>
  );
};

export default LoginWorkstationContextSelect;

LoginWorkstationContextSelect.propTypes = {
  values: propTypes.shape({
    partners: propTypes.arrayOf(
      propTypes.shape({
        partnerContextId: propTypes.number,
        name: propTypes.string,
      }),
    ),
    condominiums: propTypes.arrayOf(
      propTypes.shape({
        id: propTypes.number,
        name: propTypes.string,
      }),
    ),
  }).isRequired,
  setFieldValue: propTypes.func.isRequired,
  setCurrentStep: propTypes.func.isRequired,
  steps: propTypes.object.isRequired,
};
